import React from "react";
import SvgIcon, { SvgIconProps } from "@mui/material/SvgIcon";

const LevelIcon: React.FC<SvgIconProps> = ({ ...props }) => {
  return (
    <SvgIcon
      width="13"
      height="12"
      viewBox="0 0 13 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M12.1875 11.1875H8.9375V0.625H12.1875V11.1875ZM9.75 10.375H11.375V1.4375H9.75V10.375ZM8.125 11.1875H4.875V3.875H8.125V11.1875ZM5.6875 10.375H7.3125V4.6875H5.6875V10.375ZM4.0625 11.1875H0.8125V6.3125H4.0625V11.1875Z"
        fill="#111111"
      />
    </SvgIcon>
  );
};

export default LevelIcon;
